require('../modules/web.dom-collections.iterator');

require('../modules/es.string.iterator');

var isIterable = require('../internals/is-iterable');

module.exports = isIterable;